import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationScanRunTriggerArgs, QueryScanArgs, ScanRun } from "types/generated";

import { ScanDetailItem } from "./types";

type GetScanDetailData = {
  scan: ScanDetailItem;
};

export const GET_SCAN_DETAIL: TypedDocumentNode<GetScanDetailData, QueryScanArgs> = gql`
  query GetScanDetail($id: ID!) {
    scan(id: $id) {
      id
      name
      providerConfigs {
        type
        integrationName
      }
      space {
        id
        name
      }
      latestRun {
        id
        state
        resourceCount
        resourceStats {
          managed
          unmanaged
        }
        stateChangedAt
      }
    }
  }
`;

type ScanRunTriggerData = {
  scanRunTrigger: Pick<ScanRun, "id">;
};

export const SCAN_RUN_TRIGGER: TypedDocumentNode<ScanRunTriggerData, MutationScanRunTriggerArgs> =
  gql`
    mutation ScanRunTrigger($scan: ID!) {
      scanRunTrigger(scan: $scan) {
        id
      }
    }
  `;
